import { HttpClient, HttpStatusCode } from 'data/protocols/http';
import { generateUrl } from 'data/utils';
import { InvalidCredentialsError, UnexpectedError } from 'domain/errors';
import { HandleActivitiesAnalyticalPerTaskUseCaseInterface } from 'domain/usecases';

export class RemoteHandleActivitiesAnalyticalPerStudent
  implements HandleActivitiesAnalyticalPerTaskUseCaseInterface
{
  constructor(
    private readonly url: string,
    private readonly httpClient: HttpClient<HandleActivitiesAnalyticalPerTaskUseCaseInterface.Result>,
  ) {}

  async execute(
    params: HandleActivitiesAnalyticalPerTaskUseCaseInterface.Params,
  ): Promise<HandleActivitiesAnalyticalPerTaskUseCaseInterface.Result> {
    const { type: reportType, ...restParams } = params;

    const httpResponse = await this.httpClient.request({
      method: 'get',
      url: generateUrl(`${this.url}/${reportType}`, {
        ...restParams,
      }),
      responseType: params.type === 2 ? 'json' : 'arraybuffer',
    });

    switch (httpResponse.statusCode) {
      case HttpStatusCode.ok:
        return httpResponse.body;
      case HttpStatusCode.forbidden:
        throw new InvalidCredentialsError();
      default:
        throw new UnexpectedError(httpResponse.body.message);
    }
  }
}
